import * as React from 'react'

import { Box, RadioButton, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { BUNDLE_YEARLY_DISCOUNT } from 'modules/billing/lib/constants'
import { usePricingContext } from 'modules/onboarding/components/Pricing/PricingContext'
import { MONTH_PERIOD, YEAR_PERIOD } from 'modules/onboarding/lib/pricing/plans/utils'

const PeriodSelector = () => {
  const { isYearly, setPeriod } = usePricingContext()

  return (
    <Box flexDirection="row" gap="s8">
      <Box flexDirection="row" gap="s24">
        <RadioButton
          onChange={() => setPeriod(MONTH_PERIOD)}
          checked={!isYearly()}
          value={MONTH_PERIOD}
          label={i18n.t('pricing_plans.period_switcher.monthly')}
        />
        <RadioButton
          onChange={() => setPeriod(YEAR_PERIOD)}
          checked={isYearly()}
          value={YEAR_PERIOD}
          label={i18n.t('pricing_plans.period_switcher.yearly')}
        />
      </Box>
      <Box
        alignSelf="center"
        paddingX="s8"
        paddingY="s2"
        background="viridian200"
        borderRadius={{
          all: 'abs008',
        }}
      >
        <Text.Normal size="200" color="grey1000" weight="medium">
          {i18n.t('pricing_plans.config_plan.save_yearly', {
            discount: BUNDLE_YEARLY_DISCOUNT,
          })}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default PeriodSelector
